export const GET_PACKAGE_PRICING = "GET_PACKAGE_PRICING";
export const GET_MESSAGES = "GET_MESSAGES";
export const GET_EVENT = "GET_EVENT";
export const GET_EVENT_IMAGE = "GET_EVENT_IMAGE";
export const IS_LOADING = "IS_LOADING";
